export const EXPLORER_ADD_FOLDER_TOGGLED = 'explorer/EXPLORER_ADD_FOLDER_TOGGLED';
export const EXPLORER_ADD_PAGE_TOGGLED = 'explorer/EXPLORER_ADD_PAGE_TOGGLED';
export const EXPLORER_CREATE_MASTER_COMPONENT_TOGGLED =
  'explorer/EXPLORER_CREATE_MASTER_COMPONENT_TOGGLED';
export const EXPLORER_PAGE = 'PAGE';
export const EXPLORER_COMPONENT = 'COMPONENT';

export const SEARCH_COMPONENT_ACTION_DUPLICATE = 'DUPLICATE';
export const SEARCH_COMPONENT_ACTION_EDIT_ORIGINAL = 'EDIT_ORIGINAL';
export const SEARCH_COMPONENT_ACTIONS = [
  { text: 'Copy', action: SEARCH_COMPONENT_ACTION_DUPLICATE },
  { text: 'Edit Original', action: SEARCH_COMPONENT_ACTION_EDIT_ORIGINAL }
];

export const SEARCH_PAGE_COMPONENT_ACTION_ADD_DUPLICATE = 'ADD_DUPLICATE';
export const SEARCH_PAGE_COMPONENT_ACTION_ADD = 'ADD';
export const SEARCH_PAGE_COMPONENT_ACTIONS = [
  { text: 'Add', action: SEARCH_PAGE_COMPONENT_ACTION_ADD },
  { text: 'Copy', action: SEARCH_PAGE_COMPONENT_ACTION_ADD_DUPLICATE },
  { text: 'Edit Original', action: SEARCH_COMPONENT_ACTION_EDIT_ORIGINAL }
];
